import EventHome from '@/screens/EventHome';

export default function PrivateTabsOrganizationEventIndexRoute() {
  return <EventHome />;
}
